import { GRADES, GRADES_WITH_GRADE_6 } from '../constants/grades';
var getNextGrade = function (currentGrade) {
    var index = GRADES.indexOf(currentGrade);
    return GRADES_WITH_GRADE_6[index + 1];
};
export { getNextGrade };
